import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "./i18n";

const LanguageSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Static language list
  const languageData = [
    { code: "en", name: "English" },
    { code: "hi", name: "Hindi" },
    { code: "gu", name: "Gujrati" },
  ];

  // Initialize language from localStorage or default to English
  useEffect(() => {
    const savedLanguage = localStorage.getItem("lng") || "en";
    i18n.changeLanguage(savedLanguage);
  }, [i18n]);

  // Handle language selection
  const handleChangeLanguage = (lng) => {
    localStorage.setItem("lng", lng);
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  // Get current language name
  const languageDisplay =
    languageData.find((lang) => lang.code === i18n.language)?.name || "English";

  return (
    <div className="relative inline-block">
      <button
        className="px-4 py-2 bg-white dark:bg-slate-800 text-gray-800 dark:text-white rounded-2xl shadow hover:bg-gray-100 dark:hover:bg-slate-700 transition"
        onClick={() => setIsOpen(!isOpen)}
      >
        {languageDisplay}
      </button>

      {isOpen && (
        <ul className="absolute right-0 mt-2 w-32 bg-white dark:bg-slate-800 rounded-xl shadow-lg overflow-hidden z-50">
          {languageData.map((lang) => (
            <li key={lang.code}>
              <button
                className="w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 transition"
                onClick={() => handleChangeLanguage(lang.code)}
              >
                {lang.name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;